import { ApiReturn } from '@/modules/api.service';
import { ChangeEvent, useEffect, useState } from 'react';
import { GetRegras, SetRegra } from '@/modules/business/regras/regra.service';
import { RegraDto } from '@/api.types';
import { toast } from 'react-toastify';

export default function RegrasIndexPage() {
  const [registros, setRegistros] = useState<ApiReturn<RegraDto>>({
    objects: [],
    count: 0,
  });

  useEffect(() => {
    GetRegras(0, 1000)
      .then((result) => setRegistros(result))
      .catch((res) => {
        toast.error((res as string) + '');
      });
  }, []);

  function handleClick(id: number, checked: boolean) {
    SetRegra(id, checked)
      .then((res) => {
        toast.success(res + '');
      })
      .catch((res) => {
        toast.error((res as string) + '');
      });
  }

  return (
    <>
      <div className="row">
        <div className="col-md-8">
          <h3>Regras de Validação de Ações</h3>
          <span className="blockquote-footer pb-4 text-end">
            Controle de regras para validações dos benefícios.
          </span>
        </div>
        <hr className="pb-4" />
        <div className="tabela">
          <table className="table table-sm table-striped table-hover">
            <thead>
              <tr className="justify-content-center">
                <th scope="col">Nome</th>
                <th scope="col">Descrição</th>
                <th scope="col">Ativo</th>
              </tr>
            </thead>
            <tbody className="table-group-divider ">
              {registros &&
                registros.objects.map((item, index) => (
                  <tr key={index}>
                    <th scope="col">{item.nome}</th>
                    <td>{item.descricao}</td>
                    <td>
                      <label
                        className="logincheckbox-wrap logincheckbox-primary mb-0"
                        htmlFor={'ativo_' + item.id}
                      >
                        <input
                          title="Ativo"
                          id={'ativo_' + item.id}
                          type="checkbox"
                          defaultChecked={item.ativa}
                          onChange={(e: ChangeEvent<HTMLInputElement>) => {
                            handleClick(item.id!, e.target.checked);
                          }}
                        />
                        <span className="checkmark"></span>
                      </label>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}
